module.exports = __webpack_public_path__ + "static/media/compleja.1b3627c6.png";